import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { TextInput } from '@gitbook/react-uikit';

import type { ContentKitElementProps } from './types';

export function ContentKitTextInput(
    props: ContentKitElementProps<api.ContentKitTextInput>
): React.ReactElement {
    const { element, localState, setLocalState } = props;

    const value = String(localState[element.state] || element.initialValue || '');

    return (
        <TextInput
            disabled={element.disabled}
            size="medium"
            secureTextEntry={element.inputType === 'password'}
            value={value}
            onChangeText={(newValue) => {
                setLocalState((prev) => ({
                    ...prev,
                    [element.state]: newValue,
                }));
            }}
            placeholder={element.placeholder}
            multiline={element.multiline}
        />
    );
}
